import {createBrowserRouter} from "react-router-dom";
import Main from "../layout/Main";
import Home from "../pages/Home";
import SignUp from "../pages/SignUp";
import Login from "../pages/Login";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children:[
      {path:"/",element:<Home />},
      {path:"/signup",element:<SignUp />},
      {path:"/login",element:<Login />}
    ]
  },
]);

export default router;